import {
	COHORTS_DATA, COHORTS_LOADED, COHORTS_ERROR,
	ASA_DATA, ASA_LOADED, ASA_ERROR,
	COHORTS_FILTERS_DATA, COHORTS_FILTERS_LOADED, COHORTS_FILTERS_ERROR,
	ASA_FILTERS_DATA, ASA_FILTERS_LOADED, ASA_FILTERS_ERROR
} from "../reducers/reportsReducer";

const filtersToURLparams = (filters) => {
	let URLparams = "";
	for (let i = 0, keys = Object.keys(filters); i < keys.length; ++i) {
		if (Array.isArray(filters[keys[i]]))
			for (const arg of filters[keys[i]]) URLparams += `&${keys[i]}=${arg}`;
		else URLparams += `&${keys[i]}=${filters[keys[i]]}`;
	}
	return URLparams;
}

export const getCohortsData = (url, params) => dispatch => {

	dispatch({ type: COHORTS_LOADED, payload: false });

	fetch(`${url}?${filtersToURLparams(params)}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: COHORTS_DATA, payload: data._data });
				dispatch({ type: COHORTS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: COHORTS_ERROR, payload: err.message });
		});
}

export const getAsaData = (url, params) => dispatch => {

	dispatch({ type: ASA_LOADED, payload: false });

	fetch(`${url}?${filtersToURLparams(params)}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: ASA_DATA, payload: data._data });
				dispatch({ type: ASA_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: ASA_ERROR, payload: err.message });
		});
}

export const getCohortsFilters = (url, params) => (dispatch) => {
	fetch(`${url}?${new URLSearchParams(params).toString()}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: COHORTS_FILTERS_DATA, payload: data._data.filters });
				dispatch({ type: COHORTS_FILTERS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: COHORTS_FILTERS_ERROR, payload: err.message });
		});
}

export const getAsaFilters = (url, params) => (dispatch) => {
	fetch(`${url}?${new URLSearchParams(params).toString()}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: ASA_FILTERS_DATA, payload: data._data.filters });
				dispatch({ type: ASA_FILTERS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: ASA_FILTERS_ERROR, payload: err.message });
		});
}